import { defineWidgetSettings } from "@nexus/widget-sdk";
import { ANIMATE_VALUE_CONFIG } from "@nexus/widget-kit";
import { DEFAULT_MAX_ISPS, DETAILS, ISP_SORTS } from ".";

/** What an author sets on the blocking overview. */
export const settings = defineWidgetSettings({
  id: "blocking-overview",
  extends: [ANIMATE_VALUE_CONFIG],
  properties: {
    detail: {
      type: "string",
      title: "Detail",
      description:
        "Figures under the global ratio: ISP counts, hours per blocking status, or every ISP's rate in place of the bottom five",
      default: "isps",
      oneOf: DETAILS.map((option) => ({ const: option.value, title: option.label })),
      "x-ui": { category: "display", order: 10 },
    },
    ispSort: {
      type: "string",
      title: "Sort ISPs by",
      default: "ratio_asc",
      oneOf: ISP_SORTS.map((option) => ({ const: option.value, title: option.label })),
      "x-ui": { category: "display", order: 11, visibleIf: { detail: "all_isps" } },
    },
    maxIsps: {
      type: "integer",
      title: "Maximum ISPs shown",
      description: "The first ISPs in the chosen order",
      default: DEFAULT_MAX_ISPS,
      minimum: 1,
      maximum: 200,
      "x-ui": { category: "display", order: 11.5, visibleIf: { detail: "all_isps" } },
    },
    showFlags: {
      type: "boolean",
      title: "Show country flags",
      description: "Shows each ISP's country flag in the ranking.",
      default: true,
      "x-ui": { category: "display", order: 12 },
    },
  },
});
